import { event } from '@rategravity/frontend/modules/user-actions';
import {
  CAPACITY_PATH,
  CASH_OUT_PATH,
  LOW_CREDIT_SCORE_PATH,
  NEW_CONSTRUCTION_PATH,
  NON_PITCH,
  TOO_FAR_OUT_PATH,
  TOO_SOON_PATH,
  TRADELINE_ISSUE_PATH
} from './consult-paths';

export const pipeConsultPitch = (actionPipe, scenario, consultPath) => {
  const pipeLoadPostQuestionnairePitch = (pitchType) =>
    actionPipe.next(
      event('Load Post Questionnaire Pitch', {
        questionnaire: scenario,
        pitchType
      })
    );

  switch (consultPath) {
    case LOW_CREDIT_SCORE_PATH:
      pipeLoadPostQuestionnairePitch('Low Credit Pitch');
      break;
    case TRADELINE_ISSUE_PATH:
      pipeLoadPostQuestionnairePitch('Tradeline Issue');
    case NEW_CONSTRUCTION_PATH:
      pipeLoadPostQuestionnairePitch('New Construction');
      break;
    case TOO_FAR_OUT_PATH:
      pipeLoadPostQuestionnairePitch('3+ Months Out');
      break;
    case CAPACITY_PATH:
      pipeLoadPostQuestionnairePitch('At Consult Capacity');
      break;
    case TOO_SOON_PATH:
      pipeLoadPostQuestionnairePitch('Close date too soon');
      break;
    case NON_PITCH:
      pipeLoadPostQuestionnairePitch('Non-pitch');
      break;
    case CASH_OUT_PATH:
    default:
      pipeLoadPostQuestionnairePitch('Basic Pitch');
      actionPipe.next(
        event('Load Consult Pitch', {
          questionnaire: scenario,
          pitchType: 'Basic Pitch'
        })
      );
  }
};



// WEBPACK FOOTER //
// ./src/modules/pipe-consult-pitch.js